import modal from '@/utils/modal'

import { defineAsyncComponent } from 'vue';

const AchievementDetails = defineAsyncComponent(() => {
  return import(/* webpackChunkName: "stage-2" */'./index.vue');
});

export default function showAchievementDetails (achievement, merchantCustomerId) {
  modal.create(AchievementDetails, true, {
    provide: {
      initialAchievement: achievement,
      merchantCustomerId,
    },
  }).app;
}
